{
  "salon-search-form": {
    "buttons": {
      "customize": "Erweiterter Filter",
      "search": "SUCHEN"
    },
    "text": {
      "city": "Stadt",
      "date": "Datum",
      "treatment": "Behandlung"
    }
  }
}
